import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { useWatch } from 'react-hook-form';

const useStyles = makeStyles(() => ({
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'hidden',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '100%',
    },
}))

const SubaffiliateLevel = ({
    register,
    idx,
    idxRules,
    idxReward,
    idxModifier
}) => {
    const classes = useStyles();

    return (
        <label htmlFor={`ruleGroup[${idx}].rules[${idxRules}].rewards[${idxReward}].modifiers[${idxModifier}].subaffiliate_level`} className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
            <span className={classes.helper}>Subaffiliate level</span>
            <input
                {...register(`ruleGroup[${idx}].rules[${idxRules}].rewards[${idxReward}].modifiers[${idxModifier}].subaffiliate_level`)}
                type="text"
                id={`ruleGroup[${idx}].rules[${idxRules}].rewards[${idxReward}].modifiers[${idxModifier}].subaffiliate_level`}
                placeholder='Введите subaffiliate level'
                className={classes.text}
            />
        </label>
    )
}

export default SubaffiliateLevel;